module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "inline": true,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.Customer),
      callback: function($$v) {
        _vm.$set(_vm.query, "Customer", $$v)
      },
      expression: "query.Customer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主联系人:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.CName),
      callback: function($$v) {
        _vm.$set(_vm.query, "CName", $$v)
      },
      expression: "query.CName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同号:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.query.ContractNumber),
      callback: function($$v) {
        _vm.$set(_vm.query, "ContractNumber", $$v)
      },
      expression: "query.ContractNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理项目:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.query.ProjectType),
      callback: function($$v) {
        _vm.$set(_vm.query, "ProjectType", $$v)
      },
      expression: "query.ProjectType"
    }
  }, _vm._l((_vm.intentProjectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query.ProjectType > 1),
      expression: "query.ProjectType>1"
    }],
    attrs: {
      "label": "代理政策:"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.query.PolicyType),
      callback: function($$v) {
        _vm.$set(_vm.query, "PolicyType", $$v)
      },
      expression: "query.PolicyType"
    }
  }, _vm._l((_vm.PoliceList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.query.ProjectType == 2),
      expression: "query.ProjectType==2"
    }],
    attrs: {
      "label": "代理等级:"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.query.RebateLevel),
      callback: function($$v) {
        _vm.$set(_vm.query, "RebateLevel", $$v)
      },
      expression: "query.RebateLevel"
    }
  }, _vm._l((_vm.LevelTypes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核状态:"
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.query.AuditStatus),
      callback: function($$v) {
        _vm.$set(_vm.query, "AuditStatus", $$v)
      },
      expression: "query.AuditStatus"
    }
  }, _vm._l((_vm.queryType), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.TypeValue,
        "label": option.TypeName
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创建时间:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.query.StartAddtime),
      callback: function($$v) {
        _vm.$set(_vm.query, "StartAddtime", $$v)
      },
      expression: "query.StartAddtime"
    }
  }), _vm._v(" -\n            "), _c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.query.EndAddtime),
      callback: function($$v) {
        _vm.$set(_vm.query, "EndAddtime", $$v)
      },
      expression: "query.EndAddtime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理期限:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.query.StartDate),
      callback: function($$v) {
        _vm.$set(_vm.query, "StartDate", $$v)
      },
      expression: "query.StartDate"
    }
  }), _vm._v(" -\n            "), _c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.query.EndDate),
      callback: function($$v) {
        _vm.$set(_vm.query, "EndDate", $$v)
      },
      expression: "query.EndDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "salesman",
    attrs: {
      "label": "所属业务经理:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "选择部门"
    },
    model: {
      value: (_vm.employee.d_name),
      callback: function($$v) {
        _vm.$set(_vm.employee, "d_name", $$v)
      },
      expression: "employee.d_name"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "选择业务员"
    },
    model: {
      value: (_vm.employee.employeeName),
      callback: function($$v) {
        _vm.$set(_vm.employee, "employeeName", $$v)
      },
      expression: "employee.employeeName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "salesman-mask",
    on: {
      "click": _vm.showEmployee
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-13px"
    },
    attrs: {
      "label": "代理区域:"
    }
  }, [_c('area-select', {
    ref: "areaForm",
    attrs: {
      "label": ""
    },
    model: {
      value: (_vm.areaInfo),
      callback: function($$v) {
        _vm.areaInfo = $$v
      },
      expression: "areaInfo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuerySubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete"
    },
    on: {
      "click": _vm.onQueryClean
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addArea
    }
  }, [_vm._v("新增区域")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.lists,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Nid",
      "label": "编号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Customer",
      "label": "代理商",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CName",
      "label": "主联系人",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AuditStatusName",
      "label": "审核状态",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContractNumber",
      "label": "合同号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProjectTypeName",
      "label": "代理项目",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PolicyTypeName",
      "label": "代理政策",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "RebateLevelName",
      "label": "代理等级",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代理区域",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.ProvName) + _vm._s(scope.row.CityName) + _vm._s(scope.row.AreaName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StartDate",
      "label": "代理开始时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "EndDate",
      "label": "代理到期时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Employee_Name",
      "label": "所属业务经理",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LeasingManagerName",
      "label": "招商经理",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AddTime",
      "label": "创建时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "uopt-ctn"
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showDetails(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": (scope.row.btnVue !== 2)
          },
          on: {
            "click": function($event) {
              _vm.goToModify(scope.row)
            }
          }
        }, [_vm._v("修改")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('AddAreaDialog', {
    ref: "AddAreaDialog",
    on: {
      "reload-list": _vm.getList
    }
  }), _vm._v(" "), _c('viewDialog', {
    ref: "viewDialog"
  }), _vm._v(" "), _c('employee', {
    on: {
      "sure": _vm.selectEmployee
    },
    model: {
      value: (_vm.employeeVisiable),
      callback: function($$v) {
        _vm.employeeVisiable = $$v
      },
      expression: "employeeVisiable"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b268bb80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/AgentAreaList/index.vue
// module id = 1557
// module chunks = 1